import { IAlarmFilter } from '@interfaces/alarms/alarm';
import { IIsActive } from '@interfaces/common/common';

import { TableFilterTypes } from '@constants/table';

import { useQueryChangeMonitoringGroups } from './useQueryChangeMonitoringGroups';
import { useQueryChangeMonitoringStatuses } from './useQueryChangeMonitoringStatuses';
import { useQueryChangeMonitoringUsers } from './useQueryChangeMonitoringUsers';

interface IUseChangeMonitoringFiltersProps extends IIsActive {
	networkElementId?: string;
}

interface IUseChangeMonitoringFiltersReturn {
	filtersList: IAlarmFilter[];
	isLoadingFilters: boolean;
}

export const useChangeMonitoringFilters = ({
	networkElementId,
	isActive,
}: IUseChangeMonitoringFiltersProps): IUseChangeMonitoringFiltersReturn => {
	const {
		changeMonitoringStatuses,
		isLoadingChangeMonitoringStatuses,
	} = useQueryChangeMonitoringStatuses({
		networkElementId: networkElementId || '',
		isActive,
	});

	const {
		changeMonitoringUsers,
		isLoadingChangeMonitoringUsers,
	} = useQueryChangeMonitoringUsers({
		networkElementId: networkElementId || '',
		isActive,
	});

	const {
		changeMonitoringGroups,
		isLoadingChangeMonitoringGroups,
	} = useQueryChangeMonitoringGroups({
		networkElementId: networkElementId || '',
		isActive,
	});

	const filters: IAlarmFilter[] = [
		{
			name: 'userId',
			placeholder: 'User',
			type: TableFilterTypes.SELECT,
			data: changeMonitoringUsers,
		},
		{
			name: 'status',
			placeholder: 'Status',
			type: TableFilterTypes.SELECT,
			data: changeMonitoringStatuses,
		},
		{
			name: 'groupNumber',
			placeholder: 'Batch ID',
			type: TableFilterTypes.SELECT,
			data: changeMonitoringGroups,
		},
	];

	return {
		filtersList: filters,
		isLoadingFilters: isLoadingChangeMonitoringStatuses
			|| isLoadingChangeMonitoringUsers
			|| isLoadingChangeMonitoringGroups,
	};
};
